<div class="pnc-dialog-history-toggle-button-wrapper" [style.float]="dialogButtonDirection">
    <button class="pnc-dialog-history-toggle-button {{toggleButtonClass}}"
            data-cy="pnc-dialog-history-toggle-button"
            (click)="handleDialogClick()">
        <span [class]="toggleButtonArrowClass"
           data-cy="pnc-dialog-history-toggle-button-arrow"></span>
        <span class="button-label">{{dialogButtonTitle}}</span>
    </button>
</div>
